import { PieChartTemplateV2 } from "app/components/widget/dashboard/PieChartTemplate-v2";

import BarChartMMXDashboardWidgetFilters from "../widget-filters/BarChartMMXDashboardWidgetFilters";
import { PieChartWidget } from "../widget-types/PieChartWidget";

// import { getWidgetSubtitle, getWidgetTitle } from "../widget-utilities/widgetPpt/WidgetMetricPptHandler";

export class PieChartMMXDashboardWidget extends PieChartWidget {
    private _defaultDataFormat;

    constructor() {
        super();
        this._defaultDataFormat = "percent";
    }

    static getWidgetMetadataType() {
        return "PieChart";
    }

    static getWidgetDashboardType() {
        return "PieChart";
    }

    static getFiltersComponent() {
        return BarChartMMXDashboardWidgetFilters;
    }

    get templateUrl() {
        return "/app/components/widget/widget-templates/piechart.html";
    }

    get templateComponent() {
        return PieChartTemplateV2;
    }

    public async callbackOnGetData(response: any) {
        await super.callbackOnGetData(response);
    }
}
PieChartMMXDashboardWidget.register();
